import React from 'react';
import { useNavigation } from 'context/NavigationContext';
import { BringzzPageContainer, BringzzIcon, BringzzText } from "@bringzz/components";
import useUser from 'hooks/useUser';
import { useAuth } from 'context/AuthContext';
import { useTranslation } from 'react-i18next';

const SettingsPage = (props) => {
    const { backPress, navigate } = useNavigation();
    const { getUser } = useUser();
    const user = getUser();
    const { t } = useTranslation();

    // switch (bringzzRole) {
    //     case 1: 'pharmacist',
    //     case 4: 'shopper',
    //     case 5: 'customer'
    //   }

    const items = [
        {
            left: {
                icon: "IconUserAlt1",
                folder: "LineIcons"
            },
            label: t('component.settings.items.my_account'),
            right: {
                icon: "IconChevronRight",
                folder: "LineIcons"
            },
            path: "/settings/account",
            roles: []
        },
        {
            left: {
                icon: "IconPlus",
                folder: "LineIcons"
            },
            label: t('component.settings.items.my_pharmacy'),
            right: {
                icon: "IconChevronRight",
                folder: "LineIcons"
            },
            path: "/settings/pharmacy",
            roles: [1],
            pharmacyRoles: [1]
        },
        {
            left: {
                icon: "IconBox4",
                folder: "LineIcons"
            },
            label: t('component.settings.items.orders'),
            right: {
                icon: "IconChevronRight",
                folder: "LineIcons"
            },
            path: "/settings/pharmacy/orders",
            roles: [1]
        },
        {
            left: {
                icon: "IconBox4",
                folder: "LineIcons"
            },
            label: t('component.settings.items.orders'),
            right: {
                icon: "IconChevronRight",
                folder: "LineIcons"
            },
            path: "/consumer/orders",
            roles: [5]
        },
        {
            left: {
                icon: "IconFiles",
                folder: "LineIcons"
            },
            label: t('component.settings.items.posts'),
            right: {
                icon: "IconChevronRight",
                folder: "LineIcons"
            },
            path: "settings/posts",
            roles: [1]
        },
        {
            left: {
                icon: "IconCup",
                folder: "LineIcons"
            },
            label: t('component.settings.items.riders_club'),
            right: {
                icon: "IconChevronRight",
                folder: "LineIcons"
            },
            path: "",
            roles: [4]
        },
        {
            left: {
                icon: "IconBookmark",
                folder: "LineIcons"
            },
            label: t('component.settings.items.bookmarks'),
            right: {
                icon: "IconChevronRight",
                folder: "LineIcons"
            },
            path: "settings/bookmarks",
            roles: []
        },
        {
            left: {
                icon: "IconMapMarker",
                folder: "LineIcons"
            },
            label: t('component.settings.items.addresses'),
            right: {
                icon: "IconChevronRight",
                folder: "LineIcons"
            },
            path: "/address/",
            roles: [5, 4]
        },
        {
            left: {
                icon: "IconCreditCards",
                folder: "LineIcons"
            },
            label: t('component.settings.items.payment_methods'),
            right: {
                icon: "IconChevronRight",
                folder: "LineIcons"
            },
            path: "/settings/payment-methods",
            roles: [4]
        },
        {
            left: {
                icon: "IconSpeechBubble16",
                folder: "LineIcons"
            },
            label: t('component.settings.items.chats'),
            right: {
                icon: "IconChevronRight",
                folder: "LineIcons"
            },
            path: "/settings/chats",
            roles: [1, 5, 4]
        },
        {
            left: {
                icon: "IconQuestionCircle",
                folder: "LineIcons"
            },
            label: t('component.settings.items.faq_support'),
            right: {
                icon: "IconChevronRight",
                folder: "LineIcons"
            },
            path: "/faq",
            roles: []
        },
        {
            left: {
                icon: "IconCog",
                folder: "LineIcons"
            },
            label: t('component.settings.items.app_settings'),
            right: {
                icon: "IconChevronRight",
                folder: "LineIcons"
            },
            path: "/settings/app",
            roles: []
        },
        {
            label: t('component.settings.items.about'),
            right: {
                icon: "IconChevronRight",
                folder: "LineIcons"
            },
            path: "",
            roles: [1, 4]
        },
        {
            label: t('component.settings.items.terms'),
            right: {
                icon: "IconChevronRight",
                folder: "LineIcons"
            },
            path: "/terms",
            roles: [1, 4]
        },
        {
            label: t('component.settings.items.privacy'),
            right: {
                icon: "IconChevronRight",
                folder: "LineIcons"
            },
            path: "",
            roles: [1, 4]
        },
        {
            label: t('component.settings.items.imprint'),
            right: {
                icon: "IconChevronRight",
                folder: "LineIcons"
            },
            path: "",
            roles: [1, 4]
        },
    ]

    // Filter items based on user role
    const filteredItems = items.filter(item => { 
        if(user.pharmacyRole && item.pharmacyRoles) { 
            return !item.pharmacyRoles.length || item.pharmacyRoles.includes(user.pharmacyRole);
        } else {
            return !item.roles.length || item.roles.includes(user.userRole);
        }
    });

    const { logout } = useAuth()

    return (
        <BringzzPageContainer
            header={{
                left: <BringzzIcon
                    size="22"
                    icon="IconChevronLeft"
                    folder="LineIcons"
                    className="cursor-pointer"
                    onClick={backPress}
                />,
                title: t('component.settings.title')
            }}>

            <div>
                <div className='p-4 divide-y divide-solid'>
                    {filteredItems.map((item, index) => {
                        return <div key={index} className='flex items-center justify-between py-4 cursor-pointer' onClick={() => item.path && navigate(item.path)}>
                            <div className='flex space-x-3'>
                                {item.left && <BringzzIcon
                                    size="22"
                                    icon={item.left.icon}
                                    folder={item.left.folder}
                                />}
                                <BringzzText tag="h4" className="font-gt-maru">{item.label}</BringzzText>
                            </div>
                            {item.right && <BringzzIcon
                                size="18"
                                icon={item.right.icon}
                                folder={item.right.folder}
                            />}
                        </div>
                    })}
                    <div className='flex items-center justify-between py-4 cursor-pointer' onClick={async () => {
                        await logout()
                        navigate('/')
                    }}>
                        <div className='flex space-x-3'>
                            <BringzzText tag="h4" className="font-gt-maru underline">{t('component.settings.signout')}</BringzzText>
                        </div>
                    </div>
                </div>
            </div>
        </BringzzPageContainer>

    )
}

export default SettingsPage;
